import React from 'react';
import PublicInfoSection from './PublicInfoSection';
import PublicInfoSectionFUHSD from './PublicInfoSectionFUHSD';

const PublicInfoSectionWrapper = (props) => {
  const { parsedUserProfile } = props;

  // Conditionally render based on affiliation
  if (parsedUserProfile?.affiliation === 'FUHSD') {
    return <PublicInfoSectionFUHSD {...props} />;
  }

  return <PublicInfoSection {...props} />;
};

export default PublicInfoSectionWrapper;
